import React, { Component } from "react";
import {
  Row,
  Col,
  Form,
  Button,
  Card,
  Input,
  message,
  Select,
  Spin,
} from "antd";
import axios from "services/axios";

const FormItem = Form.Item;
const { Option } = Select;

class PricingAreaUpdate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      area: {},
      bohUsers: [],
      pricingAreas: [],
      isLoading: false,
    };
  }

  componentDidMount() {
    this.fetchAreaPricing();
    this.fetchBOH();
    this.fetchPricingAreaById(this.props.match.params.id);
  }

  async fetchAreaPricing() {
    const {
      data: { areas },
    } = await axios.get(`/misc/area-pricing`);
    this.setState({ pricingAreas: areas });
  }

  async fetchBOH() {
    const {
      data: { bohUsers },
    } = await axios.get(`/misc/boh-users`);
    this.setState({ bohUsers });
  }

  async fetchPricingAreaById(id) {
    const {
      data: { area },
    } = await axios.get(`/admin-panel/pricing-area/${id}`);
    this.setState({ area });
  }

  async updatePricingArea(e) {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      this.setState({ isLoading: true });
      if (!err) {
        let id = this.props.match.params.id;
        axios
          .patch(`/admin-panel/pricing-area/${id}/update`, values)
          .then(result => {
            message.success(`Berhasil update Area ${values.name}`);
            this.props.history.push(`/home/pricing-area`);
          })
          .catch(err => {
            this.errorMessage(err);
          });
      }
      this.setState({ isLoading: false });
    });
  }

  callback(key, props) {
    props.form.resetFields();
  }

  errorMessage(e) {
    if (e.response) {
      if (e.response.data || e.response.message) {
        message.error(
          e.response.data.message || e.response.message || e.response.data
        );
      } else {
        message.error("Error Update Area");
      }
    } else {
      message.error("Error Update Area");
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Card title="Update Pricing Area">
        <Spin tip="Sedang mengupdate Area" spinning={this.state.isLoading}>
          <Form onSubmit={e => this.updatePricingArea(e)}>
            <FormItem label="Area">
              {getFieldDecorator("name", {
                initialValue: this.state.area ? this.state.area.name : "",
                rules: [{ required: true, message: "Area wajib diisi" }],
              })(<Input />)}
            </FormItem>
            <FormItem label="Plat Nomor">
              {getFieldDecorator("kodePlat", {
                initialValue: this.state.area ? this.state.area.kodePlat : "",
                rules: [{ required: true, message: "Plat Nomor wajib diisi" }],
              })(<Input />)}
            </FormItem>
            <FormItem label="Disable Approval">
              {getFieldDecorator("isDisabled", {
                initialValue: this.state.area
                  ? this.state.area.isDisabled
                  : false,
              })(
                <Select
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="Select a Disable Approval">
                  {[true, false].map((val, index) => (
                    <Option key={val} value={val}>
                      {val ? "ON" : "OFF"}
                    </Option>
                  ))}
                </Select>
              )}
            </FormItem>
            <Row type="flex" justify="end">
              <Col>
                <Button htmlType="submit" type="primary">
                  Update
                </Button>
              </Col>
            </Row>
          </Form>
        </Spin>
      </Card>
    );
  }
}

export default Form.create()(PricingAreaUpdate);



// WEBPACK FOOTER //
// src/components/Dashboard/Area/PricingArea/PricingAreaUpdate.js